import { CssBaseline, ThemeProvider } from '@material-ui/core';
import { AppInsightsErrorBoundary } from '@microsoft/applicationinsights-react-js';
import React from 'react';
import ReactGA from 'react-ga';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import LiveChat from 'react-livechat';

import AuthProvider from './contexts/AuthContext/AuthProvider';
import E2eAuthProvider from './contexts/AuthContext/E2eAuthProvider';
import { environment } from './core/config/environment';
import { mainTheme } from './core/config/mainTheme';
import { isE2e } from './core/utils/e2e.utils';
import { reactPlugin } from './monitoring/appInsights';
import ErrorFallback from './monitoring/ErrorFallback';
import RootPage from './pages/RootPage';

const App = () => {
  const ResolvedAuthProvider = !isE2e() ? AuthProvider : E2eAuthProvider;
  ReactGA.initialize(environment.GA_KEY);

  return (
    <ThemeProvider theme={mainTheme}>
      <CssBaseline />
      <AppInsightsErrorBoundary onError={ErrorFallback} appInsights={reactPlugin}>
        <ResolvedAuthProvider>
          <LiveChat
            license={environment.LIVECHAT_LICENSE_ID}
            params={[{ name: 'system', value: 'FINDB' }]}
          />
          <GoogleReCaptchaProvider useRecaptchaNet={true} reCaptchaKey={environment.RECAPTCHA_KEY}>
            <RootPage />
          </GoogleReCaptchaProvider>
        </ResolvedAuthProvider>
      </AppInsightsErrorBoundary>
    </ThemeProvider>
  );
};

export default App;
